// Export/Import Format Constants
export const EXPORT_FORMATS = [
  { value: 'csv', label: 'CSV', icon: 'FileTextOutlined', extension: '.csv' },
  { value: 'excel', label: 'Excel', icon: 'FileExcelOutlined', extension: '.xlsx' },
  { value: 'json', label: 'JSON', icon: 'FileOutlined', extension: '.json' },
  { value: 'pdf', label: 'PDF', icon: 'FilePdfOutlined', extension: '.pdf' },
] as const;

export const IMPORT_FORMATS = [
  { value: 'csv', label: 'CSV', icon: 'FileTextOutlined', accepts: '.csv' },
  { value: 'excel', label: 'Excel', icon: 'FileExcelOutlined', accepts: '.xlsx,.xls' },
  { value: 'json', label: 'JSON', icon: 'FileOutlined', accepts: '.json' },
] as const;

// Data Types for Export/Import
export const DATA_TYPES = [
  { value: 'users', label: 'Users', icon: 'UserOutlined', table: 'users' },
  { value: 'clients', label: 'Clients', icon: 'TeamOutlined', table: 'clients' },
  { value: 'coaches', label: 'Coaches', icon: 'CrownOutlined', table: 'coaches' },
  { value: 'programs', label: 'Programs', icon: 'BookOutlined', table: 'programs' },
  { value: 'exercises', label: 'Exercises', icon: 'ThunderboltOutlined', table: 'exercises' },
  { value: 'nutrition', label: 'Nutrition', icon: 'AppleOutlined', table: 'nutrition' },
  { value: 'assessments', label: 'Assessments', icon: 'BarChartOutlined', table: 'assessments' },
  { value: 'analytics', label: 'Analytics', icon: 'DashboardOutlined', table: 'analytics' },
] as const;

// Export/Import Status
export const EXPORT_STATUS = [
  { value: 'pending', label: 'Pending', color: '#faad14' },
  { value: 'processing', label: 'Processing', color: '#1890ff' },
  { value: 'completed', label: 'Completed', color: '#52c41a' },
  { value: 'failed', label: 'Failed', color: '#f5222d' },
  { value: 'cancelled', label: 'Cancelled', color: '#d9d9d9' },
] as const;

export const IMPORT_STATUS = [
  { value: 'pending', label: 'Pending', color: '#faad14' },
  { value: 'validating', label: 'Validating', color: '#722ed1' },
  { value: 'processing', label: 'Processing', color: '#1890ff' },
  { value: 'completed', label: 'Completed', color: '#52c41a' },
  { value: 'failed', label: 'Failed', color: '#f5222d' },
  { value: 'partial', label: 'Partial Success', color: '#fa8c16' },
] as const;

// File Size Limits
export const FILE_SIZE_LIMITS = {
  csv: 50 * 1024 * 1024, // 50MB
  excel: 25 * 1024 * 1024, // 25MB
  json: 10 * 1024 * 1024, // 10MB
} as const;

// Export Options
export const EXPORT_OPTIONS = {
  includeHeaders: true,
  dateFormat: 'YYYY-MM-DD',
  timeFormat: 'HH:mm:ss',
  encoding: 'UTF-8',
  delimiter: ',',
} as const; 